import React from "react";

const FujairahTextImage = ({ title, paragraphs, image, imageAlt, reverse = false, altBg = false }) => {
  const textCol = (
    <div
      className="col-md-6 d-flex flex-column justify-content-center"
      data-aos={reverse ? "fade-left" : "fade-right"}
      data-aos-duration="1200"
      data-aos-once="true"
    >
      <h2 className="h2-title mb-4">{title}</h2>
      {paragraphs.map((p, i) => (
        <p key={i} className="ft-text-image-para">{p}</p>
      ))}
      <div className="d-flex flex-wrap gap-3 mt-3">
        <a href="tel:+971544792905" className="mini-btn primary">Call Now</a>
        <a
          href="https://wa.me/971544792905"
          target="_blank"
          rel="noopener noreferrer"
          className="mini-btn secondary-dark"
        >
          WhatsApp Now
        </a>
      </div>
    </div>
  );

  const imageCol = (
    <div
      className="col-md-6 mt-4 mt-md-0"
      data-aos={reverse ? "fade-right" : "fade-left"}
      data-aos-duration="1200"
      data-aos-once="true"
    >
      <div className="ft-image-wrapper">
        <img
          src={image}
          alt={imageAlt}
          className="ft-section-img"
          loading="lazy"
        />
      </div>
    </div>
  );

  return (
    <section className={`container-fluid py-5 overflow-hidden ft-text-image-section${altBg ? " ft-alt-bg" : ""}`}>
      <div className="container py-5">
        <div className="row align-items-stretch">
          {reverse ? (
            <>
              {imageCol}
              {textCol}
            </>
          ) : (
            <>
              {textCol}
              {imageCol}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default FujairahTextImage;
